import { gql } from '@apollo/client'
import { STORE_REGION_FRAGMENT } from '../fragments'

export const GET_COMPANY_REGIONS = gql`
  query GetCompanyRegions($companyId: ID!) {
    companyRegions(companyId: $companyId) {
      ...StoreRegion
    }
  }
  ${STORE_REGION_FRAGMENT}
`
